import { Overlay, OverlayConfig, GlobalPositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Injectable, Injector, TemplateRef, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { MyOverlayRef } from './myoverlay-ref';

import { OverlayComponent } from './overlay.component';
import { Router } from '@angular/router';
import { tools } from '../tools';

//help https://codinglatte.com/posts/angular/reusable-modal-overlay-using-angular-cdk-overlay/

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  public overlayInstance: MyOverlayRef | undefined;
  private overlayList: any[] = [];

  constructor(
    private overlay: Overlay,
    private injector: Injector,
    private router: Router,
    private tools: tools,
  ) {}

  open<R = any, T = any>(
    content: string | TemplateRef<any> | Type<any>,
    data: T & { eventType?: { modalMode?: string } },
    style?: any,
    closeOnBackdrop: boolean = false,
  ): MyOverlayRef<R> {
    let hasBackDrop: boolean = true;
    let backdropClass = ['modal-background'];
    if (data['eventType']?.['modalMode'] == 'floattingPointerEvent') backdropClass.push('cdk-overlay-transparent-backdrop');
    if (data['eventType']?.['modalMode'] == 'floatting') backdropClass.push('cdk-overlay-transparent-backdrop');
    const configs = new OverlayConfig({
      hasBackdrop: true,
      panelClass: ['modal', 'is-active', 'cdk-overlay-pane-relative'],
      backdropClass: backdropClass,
      disposeOnNavigation: true,
    });
    if (data['eventType']?.['modalMode'] == 'floattingPointerEvent') hasBackDrop = false;
    if (data['eventType']?.['modalMode'] == 'floatting') hasBackDrop = false;

    const overlayRef: any = this.overlay.create(configs);
    overlayRef['id'] = this.tools.guid(false);
    this.overlayList.push(overlayRef);
    this.overlayInstance = new MyOverlayRef<R, T>(overlayRef, content, data, style, closeOnBackdrop, this.router, this.overlayList);
    const injector = this.createInjector(this.overlayInstance, this.injector);
    let componentPortal = new ComponentPortal(OverlayComponent, null, injector);
    overlayRef.attach(componentPortal);
    return this.overlayInstance;
  }

  createInjector(ref: MyOverlayRef, inj: Injector) {
    const injectorTokens = new WeakMap([[MyOverlayRef, ref]]);
    return new PortalInjector(inj, injectorTokens);
  }
}

export interface OverlayCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R;
}
